<template>
    <GroupEditTabAccount class="pt-75" />
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue'
import { ref, onUnmounted, provide, toRefs, watch, inject } from '@vue/composition-api'
import GroupEditTabAccount from './GroupEditTabAccount.vue'
import groupsStoreModule from '../groupsStoreModule'
import router from '@/router'
import store from '@/store'

export default {
  components: { BTab, BTabs, BCard, BAlert, BLink, GroupEditTabAccount },
  setup(props) {
    const GROUP_MODULE = 'groups'
    const countries = ref([])
    const provinces = ref([])
    const group = ref(null)
    const selectedGroupId = inject('selectedGroupId')
    provide('group', group)
    provide('countries', countries)
    provide('provinces', provinces)

    if (!store.hasModule(GROUP_MODULE)){
      store.registerModule(GROUP_MODULE, groupsStoreModule)
    } 
  
    onUnmounted(() => {
       if (store.hasModule(GROUP_MODULE)) store.unregisterModule(GROUP_MODULE) 
      })

    const fetchGroup = () => {
      store.dispatch('groups/fetchGroup', { id: selectedGroupId.value }).then(response => {
        group.value = response.data.group 
        countries.value = response.data.countries
        provinces.value = response.data.provinces
      })
    }

    fetchGroup()

    watch (selectedGroupId, () => {
      fetchGroup()
    }, {deep:true})
    return {
      group,
    }
  },
}
</script>